import { AsyncStoreItem } from '@lib/store';
import { GetEmdPassengerReceiptResponse } from 'src/sdk-servicing';

/**
 * GetEmdPassengerReceipt model
 */
export interface GetEmdPassengerReceiptModel {
  model: GetEmdPassengerReceiptResponse | null;
}

/**
 * GetEmdPassengerReceiptResponse model details
 */
export interface GetEmdPassengerReceiptStateDetails extends AsyncStoreItem {}

/**
 * GetEmdPassengerReceipt store state
 */
export interface GetEmdPassengerReceiptState extends GetEmdPassengerReceiptStateDetails, GetEmdPassengerReceiptModel {}

/**
 * Name of the GetEmdPassengerReceipt Store
 */
export const GET_EMD_PASSENGER_RECEIPT_STORE_NAME = 'getEmdPassengerReceipt';

/**
 * GetEmdPassengerReceipt Store Interface
 */
export interface GetEmdPassengerReceiptStore {
  /** GetEmdPassengerReceipt state */
  [GET_EMD_PASSENGER_RECEIPT_STORE_NAME]: GetEmdPassengerReceiptState;
}
